export const dataLayerPush = (payload, clear = true) => {
  if (window.dataLayer) {
    if (clear) {
      window.dataLayer.push(function () {
        this.reset();
      });
    }

    window.dataLayer.push(payload);
  }
};

const Default = () => 'default';
export default Default;
